import { connect } from '@vfde-sails/core';
import {
    State,
    mapStateToProps,
} from '../App/selector';
import * as mapDispatch from '../App/action';
import { mountButton } from '../../components/button';
import { getOptionPageBtnProps } from '../../util/components/button.util';
import { LegalId } from '../../enums/elementId';
import { getUpdateFlags } from './update';
import {
    updateLegalDiscountedPrice,
    updateLegalLoginLink,
} from '../../components/justText';
import { removeTvConnectAccordionItem } from '../../components/accordion';

function container (state: State, actions: typeof mapDispatch) {
    const withTvConnectBtn = mountButton(LegalId.WITH_TV_CONNECT_BTN);
    const withoutTvConnectBtn = mountButton(LegalId.WITHOUT_TV_CONNECT_BTN);

    if (state.selectedTariff) {
        withTvConnectBtn?.update(getOptionPageBtnProps(state.selectedTariff, state.isGigakombi, state.isYoung, true));
        withoutTvConnectBtn?.update(getOptionPageBtnProps(state.selectedTariff, state.isGigakombi, state.isYoung));
    }

    if (state.selectedTVProduct) {
        updateLegalDiscountedPrice(state.selectedTVProduct.discountedPrice.value);
    }

    updateLegalLoginLink();

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const {
                isGigakombi,
                selectedTariff,
                isYoung,
                selectedTVProduct,
            } = newState;
            const update = getUpdateFlags(newState, oldState);

            if (update.legalOverlayButtons && selectedTariff) {
                withTvConnectBtn?.update(getOptionPageBtnProps(selectedTariff, isGigakombi, isYoung, true));
                withoutTvConnectBtn?.update(getOptionPageBtnProps(selectedTariff, isGigakombi, isYoung));
            }

            if (update.tvConnect) {
                if (selectedTVProduct) {
                    actions.loadTvFootnote();
                    updateLegalDiscountedPrice(selectedTVProduct.discountedPrice.value);
                }
                else {
                    removeTvConnectAccordionItem();
                }
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
